<div class="dialogContainer">
  <div class="header">
    <h2>Upload Documents</h2>
  </div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    </div>
  }
  @if (errorMessage()) {
    <div class="errorMessage">
      <pre>{{ errorMessage() }}</pre>
    </div>
  }
  <div class="content">
    @if (uploadFiles().length) {
      <div class="tableWrapper">
        <table class="reportTable">
          <thead>
            <tr>
              <td class="tableCell headerCell">File Name</td>
              <td class="tableCell headerCell">Document Name</td>
              <td class="tableCell headerCell">*Document Type</td>
            </tr>
          </thead>
          @for (file of uploadFiles(); track file) {
            <tr>
              <td class="tableCell">{{ file.fileName }}</td>
              <td class="tableCell"><input class="standardTextBox" [(ngModel)]="file.documentName"/></td>
              <td class="tableCell">
                <select [(ngModel)]="file.documentType">
                  @for (documentType of documentTypes(); track documentType) {
                    <option [value]="documentType.description"
                      >{{ documentType.description }}
                    </option>
                  }
                </select>
              </td>
            </tr>
          }
        </table>
      </div>
    }
  </div>
  <div mat-dialog-actions>
    <span>
      <input class="fileInput" type="file" #fileSelection id="fileSelection"
        (change)="fileChange($event);fileSelection.value=''" multiple="multiple"/>
      <label for="fileSelection">Add File</label>
    </span>
    <span class="spacer"></span>
    <span>
      <button matButton="elevated" (click)="cancel()">Cancel</button>
      <button matButton="elevated" [disabled]="isBusy() || !isReadyToUpload()" (click)="saveAndClose()">Upload</button>
    </span>
  </div>
</div>
